import { render, staticRenderFns } from "./FacturaResumen.vue?vue&type=template&id=39bef767&scoped=true&"
import script from "./FacturaResumen.vue?vue&type=script&lang=ts&"
export * from "./FacturaResumen.vue?vue&type=script&lang=ts&"
import style0 from "./FacturaResumen.vue?vue&type=style&index=0&id=39bef767&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bef767",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('39bef767', component.options)
    } else {
      api.reload('39bef767', component.options)
    }
    module.hot.accept("./FacturaResumen.vue?vue&type=template&id=39bef767&scoped=true&", function () {
      api.rerender('39bef767', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Facturacion/FacturaResumen.vue"
export default component.exports